import React from 'react';
import { Box, Button, Dialog, Heading, Hidden, Stack, VisuallyHidden } from '@ads-core/components';
import { FilterList } from '@ads-core/icons';
import { baseQueryParams } from 'src/utils';

import {
  LIANDER_CONGESTION_STATUS,
  LIANDER_CONGESTION_TYPES,
  LIANDER_REGIONS,
} from 'src/data/constantsFilters';

import { Filters } from './_Filter';

type FilterContainerProps = {
  searchLabel?: string;
  dateFilterLabel?: string;
  provinceLabel?: string;
  congestionTypeLabel?: string;
  statusLabel?: string;
};

export const FilterContainer = ({ ...props }: FilterContainerProps) => {
  const [toggleFilters, setToggleFilters] = React.useState(false);

  return (
    <>
      <Hidden below="lg">
        <Box width="100%">
          <Box
            bg="backgroundLight"
            borderRadius="brandXl"
            width="100%"
            paddingBlock={10}
            paddingLeft={8}
            paddingRight={10}
          >
            <OverviewFilters {...props} />
          </Box>
        </Box>
      </Hidden>
      <Hidden above="lg">
        <Box width="100%">
          <Dialog
            isOpen={toggleFilters}
            handleOpenChange={setToggleFilters}
            trigger={<Button style={{ width: '100%' }}>Zoekfilters</Button>}
          >
            <Box padding={10} asChild>
              <Stack gap={6}>
                <Heading size="h2">Filter</Heading>
                <Box>
                  <OverviewFilters {...props} handleToggleFilters={() => setToggleFilters(false)} />
                </Box>
                <Button afterIcon={<FilterList />} onClick={() => setToggleFilters(false)}>
                  Zoeken
                </Button>
              </Stack>
            </Box>
          </Dialog>
        </Box>
      </Hidden>
    </>
  );
};

type FilterOverviewProps = {
  handleToggleFilters?: () => void;
} & Pick<
  FilterContainerProps,
  'searchLabel' | 'dateFilterLabel' | 'provinceLabel' | 'congestionTypeLabel' | 'statusLabel'
>;

const OverviewFilters = ({
  searchLabel,
  dateFilterLabel,
  provinceLabel,
  congestionTypeLabel,
  statusLabel,
  handleToggleFilters,
}: FilterOverviewProps) => {
  const queryParams = baseQueryParams;

  return (
    <>
      <VisuallyHidden>
        <Heading size="h2">Filter</Heading>
      </VisuallyHidden>
      <Filters
        options={[
          {
            label: provinceLabel ?? 'Provincie',
            param: queryParams.province,
            options: LIANDER_REGIONS,
          },
          {
            label: congestionTypeLabel ?? 'Type Congestie',
            param: queryParams.congestion,
            options: LIANDER_CONGESTION_TYPES,
          },
          {
            label: statusLabel ?? 'Status',
            param: queryParams.status,
            options: LIANDER_CONGESTION_STATUS,
          },
        ]}
        searchLabel={searchLabel ?? 'Zoek op locatie'}
        dateFilterLabel={dateFilterLabel ?? 'Zoek op datum'}
        handleToggleFilters={handleToggleFilters}
      />
    </>
  );
};
